// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"637":"ecb06895","7166":"ecb06895","9287":"ecb06895"}[chunkId] + ".chunk.css";
};